import http from "../utils/http-common";

const login = (email: string, password: string) => {
  return http.post("/login", { email, password });
};
const logout = () => {
  return http.post("/logout");
};
const refresh = () => {
  return http.post("/refresh");
};
const validate = () => {
  return http.post("token/validate");
};
const register = ({
  email,
  password,
  username,
  first_name,
  last_name,
}: {
  email: string;
  password: string;
  username: string;
  first_name: string;
  last_name: string;
}) => {
  return http.post("/register", {
    email,
    password,
    username,
    first_name,
    last_name,
  });
};
const authService = {
  login,
  logout,
  register,
  refresh,
  validate,
};

export default authService;
